import Vuex from 'vuex'
import Vue from 'vue'
import session from './session'
import users from './users'
import complexes from './complexes'
import teams from './teams'
import fields from './fields'
import routeractions from './routeractions'
import tournaments from './tournaments'
import players from './players'
import statistics from './statistics'
import iframe from './iframe'
import sets from './sets'
import lang from './lang'
import notifications from './notifications'
import sponsorships from './sponsorships'
import imagemodal from './imagemodal'
import sanctions from './sanctions'
import { createVuexLoader } from 'vuex-loading'

const VuexLoading = createVuexLoader({
  // The Vuex module name, 'loading' by default.
  moduleName: 'loading',
  // The Vue component name, 'v-loading' by default.
  componentName: 'v-loading',
  // Vue component class name, 'v-loading' by default.
  className: 'v-loading',
});

Vue.use(Vuex)
Vue.use(VuexLoading)

export default new Vuex.Store({
  plugins: [VuexLoading.Store],
  modules: {
    statistics,
    routeractions,
    session,
    users,
    complexes,
    teams,
    fields,
    tournaments,
    players,
    iframe,
    sets,
    lang,
    notifications,
    imagemodal,
    sponsorships,
    sanctions
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js